/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonGroup, Card, Divider } from "@blueprintjs/core"
import { useNavigate } from "react-router"
import { __ } from "src/libs/utilities"
import MainStatisticForm from "./MainStatisticForm"
import BackLink from "./BackLink"

export interface IFestStatisticsProps {
    contextMethods: any // methods for context menu buttons
}
const FestStatisticForm = ( props: any ) : JSX.Element => {
    return <MainStatisticForm {...props} /> 
} 

export default FestStatisticForm

export const ChooseForm = ( ): JSX.Element => {
    const navigate      = useNavigate()
     const onChoose = (route: string) => { 
        navigate(route)
    }
    return <div className="layout-app-state flex-centered">
        <Card
            className="small-container p-0"
        >
            <div className="lead my-3 text-center ">
                {__("Choose statistics mode")}
            </div>
            <ButtonGroup fill variant="minimal" vertical size="large">
                <Divider />
                <Button onClick={() => onChoose("specials")}>
                    {__("Members")}
                </Button>
                <Button onClick={() => onChoose("users")}>
                    {__("Users and rates")}
                </Button> 
                <Button onClick={() => onChoose("schools")}>
                    {__("Schools")}
                </Button>
                <Divider />
                <BackLink intent="none" />
            </ButtonGroup>
        </Card>
    </div>
}